import React from 'react';
import css from './Link.css';

export default class ViewAllUpcomingLink extends React.Component {
  render() {
    return <a href="../instructor/upcoming.html" className={css['link']}>View all upcoming appointments</a>;
  }
}
